import { createReducer, on } from '@ngrx/store';
import {
  AUDIT_FIND_SUCCESS,
  AUDIT_FAILURE,
  AUDIT_UPDATE_FORM,
  AUDIT_RESET_ERROR,
  AUDIT_RESET,
  AUDIT_RESET_FORM,
  AUDIT_FIND_ALL_SUCCESS,
  AUDIT_EDIT_MODE,
  AUDIT_CLEAR_STATE,
  AUDIT_UPDATE_ID,
  AUDIT_UPDATE_LOADING,
  AUDIT_UPDATE_INMUTABLE,
  AUDIT_UPDATE_FORM_VALID,
} from '../actions';
import { ResponseBadRequest } from '@core/interfaces';
import {
  Auditoria,
  AuditoriaForm,
} from '@core/models';
import { transformAuditData } from '@core/helpers';

export interface AuditState {
  loading: boolean;
  editMode: boolean;
  isEditing: boolean;
  auditId: string | null;
  audit: Auditoria | null;
  auditList: Auditoria[];
  auditForm: AuditoriaForm | null;
  auditInmutable: boolean,
  formValid: boolean,
  error: ResponseBadRequest | null;
}

export const initialState: AuditState = {
  loading: false,
  isEditing: false,
  editMode: false,
  auditId: null,
  audit: null,
  auditList: [],
  auditForm: null,
  auditInmutable: false,
  formValid: false, 
  error: null,
};

export const auditReducer = createReducer(
  initialState,
  on(AUDIT_EDIT_MODE, (state, { editMode, isEditing }) => ({ ...state, editMode, isEditing })),
  on(AUDIT_FIND_SUCCESS, (state, { audit }) => ({ ...state, audit: transformAuditData(audit) })),
  on(AUDIT_FIND_ALL_SUCCESS, (state, { auditList }) => ({ ...state, auditList })),
  on(AUDIT_FAILURE, (state, { error }) => ({ ...state, error })),
  on(AUDIT_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(AUDIT_UPDATE_FORM, (state, { auditForm }) => ({ ...state, auditForm })),
  on(AUDIT_UPDATE_FORM_VALID, (state, { formValid }) => ({ ...state, formValid })),
  on(AUDIT_UPDATE_INMUTABLE, (state, { inmutable }) => ({ ...state, auditInmutable: inmutable })),
  on(AUDIT_UPDATE_ID, (state, { auditId }) => ({ ...state, auditId })),
  on(AUDIT_RESET, (state) => ({ ...state, audit: null, auditId: null, auditForm: null })),
  on(AUDIT_RESET_ERROR, (state) => ({ ...state, error: null })),
  on(AUDIT_RESET_FORM, (state) => ({ ...state, auditForm: null, loading: false })),
  on(AUDIT_CLEAR_STATE, (state) => ({ ...state, ...initialState, loading: state.loading })),
);